module.exports = __webpack_public_path__ + "c7e2c431c2ba29ce0ae69631e25026d9.svg";